const ONBOARDING_KEYS = {
  welcomeSeen: "bmc_welcome_seen",
  catalogTourDone: "bmc_catalog_tour_done",
  vehicleTourDone: "bmc_vehicle_tour_done",
  offersTourDone: "bmc_offers_tour_done",
};

export default ONBOARDING_KEYS;
